import { z } from 'zod';
/**
 * One hit in the company picker. Carries whichever account already holds this
 * company, so the person assigning can see that a hit is taken before choosing
 * it rather than after — joining somebody else's customer is the mistake this
 * picker exists to prevent.
 */ export const HubspotCompanySearchHitSchema = z.object({
    companyId: z.string(),
    name: z.string().nullable(),
    domain: z.string().nullable(),
    /** The account already holding this company, if any. */ linkedAccount: z.object({
        _id: z.string(),
        name: z.string().nullable()
    }).nullable()
});
export const SearchHubspotCompaniesResponseSchema = z.object({
    companies: z.array(HubspotCompanySearchHitSchema)
});
/**
 * Below this many characters nobody searches, neither the picker nor the
 * server: one place for the number, so the two cannot drift apart.
 */ export const CRM_SEARCH_MIN_LENGTH = 3;
/** The query of every CRM search (companies today, contacts alike). */ export const CrmSearchQuerySchema = z.object({
    q: z.string().trim().max(200).default('')
});

//# sourceMappingURL=search-hubspot-companies.schema.js.map